import * as React from "react";
import { useState } from "react";
import {
  Button,
  Text,
  View,
  StyleSheet,
  TouchableOpacity,
  Image,
} from "react-native";
import { NavigationContainer } from "@react-navigation/native";
import {
  createStackNavigator,
  HeaderBackButton,
} from "@react-navigation/stack";
import { Icon } from "react-native-elements";
import { stripe } from "@stripe/stripe-js";
import * as firebase from "firebase";
import "firebase/firestore";
import { useRoute, StackRouter } from "@react-navigation/native";

import HomeScreen from "../FlyBy/HomeScreen.js";
import CartScreen from "../FlyBy/CartScreen.js";
import SuccessScreen from "./SuccessScreen.js";
import CheckoutScreen from "./CheckoutScreen.js";

const firebaseConfig = {
  apiKey: "AIzaSyDaeu9mbyaZEUAiMUWIEiSu5cStW--Ga8g",
  authDomain: "flyby-nyc20.firebaseapp.com",
  databaseURL: "https://flyby-nyc20.firebaseio.com",
  projectId: "flyby-nyc20",
  storageBucket: "flyby-nyc20.appspot.com",
  messagingSenderId: "479082390845",
  appId: "1:479082390845:web:6a04b019caa0b06bd11154",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const HomeStack = createStackNavigator();

function PoweredByStripeComp(props) {
  return (
    <img
      src={require("./assets/stripev4.png")}
      style={{ height: 24, marginRight: 16 }}
    />
  );
}
function RunningManLogoComp(props) {
  return (
    <img
      src={require("./assets/runningMan.png")}
      style={{ height: 44, marginRight: 12 }}
    />
  );
}

//const Tab = createBottomTabNavigator();
export default class App extends React.Component {
  constructor(props) {
    super(props);
  }

  linking = {
    config: {
      screens: {
        Home: "restaurant/:id/table/:number",
      },
    },
  };

  render() {
    document.body.style.overflow = "hidden";
    return (
      <NavigationContainer
        linking={this.linking}
        fallback={<Text>Loading...</Text>}
      >
        <HomeStack.Navigator>
          <HomeStack.Screen name="Home" component={HomeScreen} />
          <HomeStack.Screen name="Order" component={CartScreen} />
          <HomeStack.Screen
            name="Payment"
            component={CheckoutScreen}
            options={{
              headerRight: () => <PoweredByStripeComp />,
            }}
          />
          <HomeStack.Screen
            name="Success"
            component={SuccessScreen}
            options={({ route }) => ({
              headerShown: false,
            })}
          />
        </HomeStack.Navigator>
      </NavigationContainer>
    );
  }
}

// <HomeStack.Screen
//   name="Home"
//   component={HomeScreen}
//   options={{
//     headerRight: () => <RunningManLogoComp />,
//   }}
// />
// <HomeStack.Screen name="Cart" component={CartScreen} />
// <HomeStack.Screen
//   name="Payment"
//   component={CheckoutScreen}
// options={{
//   headerRight: () => <PoweredByStripeComp />,
// }}
// />

//
// <HomeStack.Screen name="Home" component={HomeScreen} />
// <HomeStack.Screen name="Cart" component={CartScreen} />
// <HomeStack.Screen
//   name="Payment"
//   component={CheckoutScreen}
//   options={{
//     headerRight: () => <PoweredByStripeComp />,
//   }}
// />
// <HomeStack.Screen name="Home" component={HomeScreen} />
// <HomeStack.Screen name="Cart" component={CartScreen} />
// <HomeStack.Screen name="Payment" component={CheckoutScreen} />
// <HomeStack.Screen name="Success" component={SuccessScreen} />
